module.exports = __webpack_public_path__ + "img/f5b6c96.svg";